import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
const Home = r => require.ensure([], () => r(require('@/components/Home')))
const Login = r => require.ensure([], () => r(require('@/views/login')))
const dashboard = r => require.ensure([], () => r(require('@/views/dashboard')))
const workflow_list = r => require.ensure([], () => r(require('@/views/workflow_list'))) // 流程图
const workflow_list_edit = r => require.ensure([], () => r(require('@/views/workflow_list_edit'))) // 流程图编辑
const machine_list = r => require.ensure([], () => r(require('@/views/machine_list'))) // 流程图
const machine_list_edit = r => require.ensure([], () => r(require('@/views/machine_list_edit'))) // 流程图
const init = r => require.ensure([], () => r(require('@/oidcServices/init'))) // 流程图
const oidcSignin = r => require.ensure([], () => r(require('@/views/oidc/signin-oidc'))) // 流程图
const oidcSignout = r => require.ensure([], () => r(require('@/views/oidc/signout-oidc'))) // 流程图
const silentRenew = r => require.ensure([], () => r(require('@/views/oidc/silent-renew'))) // 流程图
const homeNew = r => require.ensure([], () => r(require('@/views/home/index'))) // 流程图

Vue.use(Router)

export default new Router({
  // 因为地址后面烦人的/#/ 加上这句话就OK
  mode: 'history',
  routes: [
    {
      path: '/homeNew',
      name: 'homeNew',
      component: homeNew
    },
    {
      path: '/init',
      name: 'init',
      component: init
    },
    {
      path: '/',
      name: 'home',
      component: homeNew
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: dashboard
    },
    {
      path: '/workflow_list_edit',
      name: 'workflow_list_edit',
      component: workflow_list_edit
    },
    {
      path: '/workflow_list', // 流程图列表
      name: 'workflow_list',
      component: workflow_list
    },
    {
      path: '/machine_list', // 机器图列表
      name: 'machine_list',
      component: machine_list
    },
    {
      path: '/signin-oidc',
      name: 'signin-oidc',
      component: oidcSignin
    },
    {
      path: '/signout-oidc',
      name: 'signout-oidc',
      component: oidcSignout
    },
    {
      path: '/silent-renew',
      name: 'silent-renew',
      component: silentRenew
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js